import gql from 'graphql-tag';

export const mutationDeleteLogo = gql`
  mutation deleteLogo (
    $id: DokkioID!
  ) {
    deleteLogo (
      id: $id
    )
  }
`;

export default mutationDeleteLogo;
